import React from 'react';

import PropTypes from 'prop-types';
import StatesList from './index';

function StatesListSection({ heading, data }) {
  return (
    <section className='hidden px-4 py-12 odd:bg-base-100 even:bg-base-200 md:block md:p-20'>
      <div className='mx-auto max-w-7xl p-0'>
        <StatesList heading={heading} data={data} />
      </div>
    </section>
  );
}

export default StatesListSection;

StatesListSection.propTypes = {
  heading: PropTypes.string.isRequired,
  data: PropTypes.array.isRequired,
};
